import * as _ from 'lodash';
import * as toastr from 'toastr';

import * as UserManagement from '../../';
import * as Common from '../../../../Common/modules';
import * as Models from '../../../../Models';
import * as Services from '../../../../Services';

export interface IRoleSearchCtrlScope {
  roleSearchCtrl: RoleSearchCtrl;
}

export class RoleSearchCtrl {
  private showLogging: boolean = false;
  private roleList: Models.Auth.RoleList.RoleList = new Models.Auth.RoleList.RoleList();
  private roles: Models.RoleModel.IRoleModel[];

  public roleToAdd: string;

  public static $inject = [
    "$scope",
    "$state",
    "RoleRetrievalService",
    "RoleSaveService",
    "UserService",
    "igs.messageBox",
  ];

  constructor(
    $scope: IRoleSearchCtrlScope,
    private $state: angular.ui.IStateService,
    private roleRetrievalService: UserManagement.services.RoleRetrivalService.IRoleRetrievalService,
    private roleSaveService: UserManagement.services.RoleSaveService.IRoleSaveService,
    private userService: Services.UserService.IUserService,
    private messageBox: any,
  ) {
    $scope.roleSearchCtrl = this;
    // Only user admins can manage roles
    this.userService.isUserInRole(this.roleList.manageUsersAdmin).then((response) => {
      if (response === false) {
        this.$state.go("main.customersearchv2");
      }
    });

    this.getAndSetRoles();
  }

  public addRole = () => {
    if (this.showLogging) {
      console.log("adding user...");
    }
    if (!this.roleToAdd) {
      toastr.error("Please enter a valid permission", "Error");
      return;
    }

    var openBox = this.messageBox.open(
      "Create New Permission",
      "Are you sure you want to create this new permission?",
      [
        { label: "OK", cssClass: "btn-success", result: true },
        { label: "Cancel", cssClass: "btn-cancel", result: false },
      ],
    );

    openBox.then((result: boolean) => {
      if (result) {
        var role = new Models.RoleModel.RoleModel(this.roleToAdd);
        this.roleSaveService.saveRole(role).then(
          () => {
            this.$state.reload();
            toastr.success("Permission Added", "Success");
          },
          () => {
            toastr.error("There was a problem saving the permission", "Error");
          },
        );
      }
    });
  };

  private getAndSetRoles(): ng.IPromise<void> {
    if (this.showLogging) {
      console.log("getting all roles...");
    }
    return this.roleRetrievalService.getAllRoles(false).then((roles: Models.RoleModel.IRoleModel[]) => {
      this.roles = _.sortBy(roles, "name");
    });
  }
}
